import React from "react";
import { Button, Tooltip } from "@material-ui/core";

const ButtonTooltip = ({ children, title, buttonStyle }) => {
  return (
    <Tooltip title={title}>
      <Button style={buttonStyle} variant="outlined">
        {children}
      </Button>
    </Tooltip>
  );
};

export default ButtonTooltip;



// WEBPACK FOOTER //
// ./src/components/common/ButtonTooltip.js